/**
 * Sineba – ürün sayfası: "Teklif iste" ve "WhatsApp ile sor" düğmelerine ürün adını ekler.
 * Düğmeler templates/product.json içindeki "teklif_buton" ve "wa_buton" bloklarıdır.
 */
(function () {
  function init() {
    var h1 = document.querySelector('.product-meta__title');
    if (!h1) return;
    var title = h1.textContent.trim();
    var skuEl = document.querySelector('.product-meta__sku-number');
    var sku = skuEl ? skuEl.textContent.trim() : '';
    var label = sku && title.indexOf(sku) === -1 ? title + ' (' + sku + ')' : title;
    var pageUrl = location.origin + location.pathname;

    var quote = document.querySelector('[data-block-id="teklif_buton"] a');
    if (quote) quote.href = '/pages/contact?urun=' + encodeURIComponent(label);

    var wa = document.querySelector('[data-block-id="wa_buton"] a');
    if (wa) {
      var msg = 'Merhaba, ' + label + ' için fiyat ve teslim süresi bilgisi almak istiyorum. ' + pageUrl;
      wa.href = 'https://wa.me/905325696763?text=' + encodeURIComponent(msg);
      wa.target = '_blank';
      wa.rel = 'noopener';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('variant:changed', init);
})();